
import {defineComponent, PropType} from 'vue'
import type {InternetAndMobileOffersDto,} from "../../models/InternetAndMobileOffersDto";
import SkeletonInternetAndMobileCard from "../../components/SkeletonInternetAndMobileCard.vue";
import Breadcrumb from "../../../common/components/ob1/Breadcrumb.vue";
import {
    DigitalCartTooltipDto,
    InternetAndMobileOffersResponseSuccess,
    InternetAndMobilePackDto,
    LegalMentionsDto
} from "../../models/InternetAndMobileApiResponse";
import {InternetAndMobileService} from "../../services/InternetAndMobileService";
import LinkFoldUnFold from "../../../common/components/ob1/LinkFoldUnfold.vue";
import InternetAndMobileCard from "../../components/InternetAndMobileCard.vue";
import {alignDivsHeightsByLine} from "../../../orange/broadband/utils/AlignDivHeightsUtil";
import ShowcaseFaq from "../../../orange/broadband/demands/showcase/internetandmobileoffers/components/ShowcaseFaq.vue";
import EligibilityResult
    from "../../../orange/broadband/demands/showcase/internetandmobileoffers/components/eligibility/EligibilityResult.vue";
import DigitalCartTooltip from "../../../common/components/vue/tooltip/DigitalCartTooltip.vue";
import Banner from "../../../fmfmo/common/components/Banner.vue";

export default defineComponent({
    name: 'InternetAndMobileOffers',
    components: {
        Banner,
        EligibilityResult,
        ShowcaseFaq,
        InternetAndMobileCard,
        LinkFoldUnFold,
        Breadcrumb,
        SkeletonInternetAndMobileCard,
        DigitalCartTooltip
    },
    props: {
        dto: {
            type: Object as PropType<InternetAndMobileOffersDto>,
            required: true
        },
        token: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            internetAndMobileOffersResponse: null as PropType<InternetAndMobileOffersResponseSuccess | null>,
        }
    },
    computed: {
        offerPackages(): Array<InternetAndMobilePackDto> | null {
            return this.internetAndMobileOffersResponse?.internetAndMobilePacks;
        },
        digitalCartTooltip(): DigitalCartTooltipDto | null {
            return this.internetAndMobileOffersResponse?.digitalCartTooltip;
        },
        legalMentions(): LegalMentionsDto | null {
            return this.internetAndMobileOffersResponse?.legalMentions;
        },
        topEligibilityResult() {
            return this.internetAndMobileOffersResponse?.topEligibilityResult;
        }
    },
    mounted() {
        InternetAndMobileService.getOffers().then((response: InternetAndMobileOffersResponseSuccess) => {
            this.internetAndMobileOffersResponse = response;

            const statParameters = { ...this.internetAndMobileOffersResponse?.statParameters };
            if (statParameters) {
                // @ts-ignore - L'API Tms n'est pas typée
                Tms.view(statParameters);
            }
        });
        window.addEventListener("resize", () => {
            this.alignElements();
        });
    },
    updated() {
        this.$nextTick(function () {
            this.alignElements();
        })
    },
    beforeDestroy() {
        window.removeEventListener("resize", () => {
            this.alignElements();
        });
    },
    methods: {
        alignElements() {
            const listOfDivToAlign = [
                "banner-wrapper",
                "mobile-title-wrapper",
                "mobile-price-wrapper",
                "mobile-link-wrapper",
                "internet-title-wrapper",
                "internet-price-wrapper",
                "internet-link-wrapper",
                "price-wrapper",
                "message-wrapper"
            ];
            alignDivsHeightsByLine(listOfDivToAlign);
        },
    }
})
